import { useContext, useEffect } from "react";
import Header from "../../components/header/header";
import { Button } from "../../../../components/button/button";
import { WelcomePageStyled } from "./welcome-page.style";
import {
  USER_APPOINTMENT_ACTIONS,
  UserAppointmentContext,
} from "../../context/user-appointment-context";

const WelcomePage = () => {
  const {
    state: { activeStep },
    userDispatcher,
  } = useContext(UserAppointmentContext);

  useEffect(() => {
    localStorage.removeItem("userAppToken");
  }, []);

  return (
    <WelcomePageStyled>
      <Header
        iscenteraligned
        title="Welcome"
        description="Booking an appointment with us is simple and quick. 
Just follow a few easy steps, and you'll be done in 5 minutes!"
      />
      <Button
        onClick={() =>
          userDispatcher({
            type: USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP,
            payload: activeStep + 1,
          })
        }
      >
        Get Started
      </Button>
    </WelcomePageStyled>
  );
};

export default WelcomePage;
